import React from 'react';
import ChallengeMedia from '../school/ChallengeMedia';
import { Image } from 'react-bootstrap';
import deleteIconImage from '../../../assets/icon/icon-delete.svg';
import editIconImage from '../../../assets/icon/edit_ic.svg';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import selectArrow from '../../../assets/icon/blue_arrow.svg';
import ClassImg from '../../../assets/images/old-letsgo.svg';
import WorkingImg from '../../../assets/icon/Working_on.svg';
import CompletedImg from '../../../assets/icon/Completed.svg';
import {
  CAMP,
  CHALLENGE_ROUTE,
  EVENT_ROUTE,
  SPECIAL_CHALLENGE_ROUTE,
} from '../../../constants/routes.constants';
import { useHistory } from 'react-router';
import '../next_challenge/scss/challenge.card.scss';

export default function ChallengeList(props) {
  const { challengeList, tabFlag, handleDelete, loading } = props;
  const history = useHistory();

  const redirect = (challenge) => {
    let path = CHALLENGE_ROUTE;
    let encodeQuery = btoa(`{"id":${challenge?.id}, "slug":"challenge"}`);
    if (challenge?.special_camp?.id) {
      path = SPECIAL_CHALLENGE_ROUTE;
      encodeQuery = btoa(`{"id":${challenge?.id}, "slug":"special-challenge"}`);
    }
    if (challenge?.is_event) {
      path = EVENT_ROUTE;
      encodeQuery = btoa(`{"id":${challenge?.id}, "slug":"event"}`);
    }
    history.push({
      pathname: path,
      search: `?encrypt=${encodeQuery}`,
    });
  };

  const handleChallengeClick = (challenge) => {
    if (
      challenge?.created_by?.user_type === 'camp master' &&
      !challenge?.agora_group_id &&
      challenge?.treehouse_user?.agora_group_id
    ) {
      createGroup(challenge);
    } else {
      redirect(challenge);
    }
  };

  const handleEdit = (challenge) => {
    history.push(`${CAMP}/edit-challenge/${challenge?.id}`);
  };

  return challengeList && challengeList.length > 0 ? (
    <div className="section-div">
      <div>
        <div className="completed-challenges-container withbtn has-1">
          {challengeList.map((challenge) => {
            return (
              <div
                className="challenge-card challenge-myroom card-1 card"
                key={challenge?.created_at}
              >
                <div
                  role="button"
                  onClick={(e) => {
                    if (e.target.classList.contains('campChallengeClick')) {
                      handleChallengeClick(challenge);
                    }
                  }}
                >
                  <ChallengeMedia repo={challenge} for="list" />
                </div>
                <div className="custom-title-and-desc card-body">
                  <div className="last-column justify-box">
                    <div className="edit-delete-wrapper">
                      <div
                        className="fv-edit-wrapper"
                        onClick={() => handleEdit(challenge)}
                      >
                        <img src={editIconImage} />
                      </div>
                      {/* {tabFlag !== 'previous' && ( */}
                      <img
                        role="button"
                        src={deleteIconImage}
                        onClick={() => handleDelete(challenge)}
                      />
                      {/* )} */}
                    </div>
                  </div>
                  <div className="feed-title-bar" id="3">
                    <div className="challenge-title card-title h5">
                      {challenge?.title || challenge?.name}
                    </div>
                    <p className="challenge-desc card-text">
                      {challenge?.description}
                    </p>
                    <div className="additional-infos">
                      <div className="left">
                        <div className="accepted">
                          <div className="avatar-icon-div">
                            <div className="avatar-icon-wrapper">
                              {challenge?.accepted_dependents?.length > 0 ? (
                                challenge?.accepted_dependents?.map(
                                  (kid, key) => {
                                    return (
                                      <span key={key}>
                                        <div className="avatar-wrapper">
                                          <div className="smallest-type">
                                            <div className="avatar-image">
                                              <img
                                                src={getUserProfileUrl(kid)}
                                                className="rounded-circle overlap-item"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                    );
                                  }
                                )
                              ) : (
                                <span>
                                  <div className="avatar-wrapper">
                                    <div className="smallest-type">
                                      <div className="avatar-image">
                                        <img
                                          src={WorkingImg}
                                          className="rounded-circle overlap-item"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="submission-count opa">
                            {challenge?.accepted_dependent_count} working on
                          </div>
                        </div>
                        <div className="submitted">
                          <div className="avatar-icon-div">
                            <div className="avatar-icon-wrapper">
                              {challenge?.completed_dependents?.length > 0 ? (
                                challenge?.completed_dependents?.map(
                                  (kid, key) => {
                                    return (
                                      <span key={key}>
                                        <div className="avatar-wrapper">
                                          <div className="smallest-type">
                                            <div className="avatar-image">
                                              <img
                                                src={getUserProfileUrl(kid)}
                                                className="rounded-circle overlap-item"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                    );
                                  }
                                )
                              ) : (
                                <span>
                                  <div className="avatar-wrapper">
                                    <div className="smallest-type">
                                      <div className="avatar-image">
                                        <img
                                          src={CompletedImg}
                                          className="rounded-circle overlap-item"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="submission-count opa">
                            {challenge?.completed_dependent_count} completed
                          </div>
                        </div>
                      </div>
                      <div
                        role="button"
                        onClick={() => handleChallengeClick(challenge)}
                        style={{ alignSelf: 'center' }}
                      >
                        <img src={selectArrow} alt="" id="3" className="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    !loading && (
      <div className="section-div">
        <div className="myroom-creation-container">
          <div className="choose-class">
            <Image className="profile-image" src={ClassImg} />
            Choose your tribe first before creating your Challenge
          </div>
        </div>
      </div>
    )
  );
}